import type { FaireProductEntity } from "../../entity_types/product";

export const p_t57k5ytx66: FaireProductEntity = {
  token: "p_t57k5ytx66",
  type: "product",
  name: "Tea Towels Nautical - Anchor All Over Printed",
  brandName: "Accent Linen",
  imageUrl:
    "https://cdn.faire.com/fastly/738e5f90b9f35879d805b5ecd53f04dd249c1f64860545d8d24b4643c3892322.png",
  priceDollars: 2.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/7dace2d1385c2d8d8de126caa80da65d1248dfde5acd387cd558250b8390697b.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
